import React, { useEffect, useState, useCallback } from "react";
import FilterDropdown from "../../components/common/FilterDropdown";
import AddNewRecipeButton from "./components/AddNewRecipeButton";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getAllRecipeData,
  getRecipeByTag,
  getRecipeDataById,
  uploadRecipeData,
  deleteRecipeDataById,
  updateStatusRecipeData
} from "../../api/recipe/uploadRecipe";
import RecipeTable from "./components/RecipeTable";

const AddNewRecipe = () => {
  const [plans, setPlans] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [error, setError] = useState(null);
  const [uploadedJson, setUploadedJson] = useState(null);
  const [planData, setPlanData] = useState({});
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [shouldRedirect] = useState(false);
  const [currentModal, setCurrentModal] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const filterOptions = ["All", "Breakfast", "Lunch", "Dinner"];
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const openModal = (modalNumber) => {
    setCurrentModal(modalNumber);
  };
  const fetchPlans = useCallback(async () => {
    try {
      const data =
        selectedFilter === "All"
          ? await getAllRecipeData()
          : await getRecipeByTag(selectedFilter);
      setPlans(data?.recipes);
    } catch (error) {
      setError("Failed to fetch plans");
      console.error(error);
    }
  }, [selectedFilter]);
  useEffect(() => {
    fetchPlans().then();
  }, [fetchPlans, selectedFilter]);

  const convertTimestamp = (createdAtSeconds) => {
    const uploadDate = new Date(createdAtSeconds * 1000);
    return uploadDate.toLocaleDateString();
  };

  const tableHeader = [
    { label: "Sr. No", width: "5%" },
    { label: "Workout Details", width: "30%" },
    { label: "Uploaded on", width: "25%" },
    { label: "Status", width: "15%" },
    { label: "Edit", width: "5%" },
    { label: "Action", width: "5%" },
    { label: "Download", width: "5%" },
  ];
  const handleEditClick = async (planId) => {
    setSelectedPlanId(planId);
    try {
      const data = await getRecipeDataById(planId);
      setUploadedJson(data);
      setPlanData(data);
      openModal(2);
    } catch (error) {
      setError(error.message);
      console.error("Failed to load plan:", error.message);
    }
  };

  const showToast = (message, success) => {
    if (success) {
      toast.success(message);
    } else {
      toast.error(message);
    }
  };

  const handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileSizeLimit = 50 * 1024 * 1024;
      if (selectedFile.size > fileSizeLimit) {
        setErrorMessage(
          "File size exceeds the 50MB limit. Please upload a smaller file."
        );
        setFileName(null);
        return;
      }

      const validExtensions = ["json"];
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
      if (!validExtensions.includes(fileExtension)) {
        setErrorMessage("Please upload a valid JSON file.");
        setFileName(null);
        return;
      }

      setErrorMessage(null);
      setFileName(selectedFile.name);
      setFile(selectedFile);

      const reader = new FileReader();
      reader.onload = () => {
        try {
          const jsonData = JSON.parse(reader.result);
          setUploadedJson(jsonData);
          setPlanData(jsonData);
        } catch (e) {
          setErrorMessage("The uploaded file is not a valid JSON file.");
          setFile(null);
        }
      };
      reader.readAsText(selectedFile);
    }
  };


  const toggleStatus = async (plan) => {
    const response = await updateStatusRecipeData(plan?.id);
    if (response) {
      showToast(
        `Success! Your recipe plan Status saved.`,
        true
      );
      setFile(null);
      setFileName(null);
      setUploadedJson(null);
      setPlanData({});
      await fetchPlans()
    }
  };

  const handleSubmit = async (formData) => {
    if (!file) {
      showToast("No file selected for upload.", false);
      return;
    }

    const reader = new FileReader();
    reader.onload = async () => {
      try {
        const jsonData = JSON.parse(reader.result);
        jsonData.recipe.cover_image_url = formData.bannerImageUrl;

        const updatedFile = new File([JSON.stringify(jsonData)], fileName, {
          type: "application/json",
        });

        const formDataToUpload = new FormData();
        formDataToUpload.append("file", updatedFile, fileName);

        const response = await uploadRecipeData(formDataToUpload, fileName);
        if (response) {
          showToast(
            `Success! Your recipe plan has been saved. Refer to the add new recipe for details.`,
            true
          );

          setFile(null);
          setFileName(null);
          setUploadedJson(null);
          setPlanData({});
          window.location.assign("/add-new-recipe");
        }
      } catch (error) {
        showToast("Failed to upload plan.", false);
      }
    };
    reader.readAsText(file);
  };

  const handleAddNewPlanClick = () => {
    setSelectedPlanId(null);
  };

  const handleImageUrlChange = (url) => {
    setPlanData((prevData) => ({
      ...prevData,
      cover_image_url: url,
    }));
    setUploadedJson((prevJson) => ({
      ...prevJson,
      recipe: {
        ...prevJson.recipe,
        cover_image_url: url,
      },
    }));
  };

  const handleVideoUrlChange = (url) => {
    setPlanData((prevData) => ({
      ...prevData,
      plan_video: url,
    }));
  };

  const modalHeading = "Recipe Manager";
  const modalAddBtn = "Add New Recipe";
  if (shouldRedirect) {
    return <Navigate to="/add-new-recipe" replace />;
  }
  // Pagination Logic
  const totalPages = Math.ceil(plans.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedPlans = plans.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Recipe?")) {
      try {
        const response = await deleteRecipeDataById(id);
        if (response.message) {
          toast.success("Recipe deleted successfully!");
          await fetchPlans();
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        toast.error("Failed to delete Recipe file.");
        console.error("Error deleting Recipe:", error);
      }
    }
  }
  return (
    <div className="right-side-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6">
            <h2>{modalHeading}</h2>
          </div>
          <div className="col-sm-6">
            <div className="btn-sec">
              <FilterDropdown
                filterOptions={filterOptions}
                onFilterChange={setSelectedFilter}
              />{" "}
              <AddNewRecipeButton
                setCurrentModal={setCurrentModal}
                currentModal={currentModal}
                openModal={openModal}
                modalAddBtn={modalAddBtn}
                selectedPlanId={selectedPlanId}
                handleFileUpload={handleFileUpload}
                handleSubmit={handleSubmit}
                uploadedJson={uploadedJson}
                planData={planData}
                errorMessage={errorMessage}
                fileName={fileName}
                onAddNewPlanClick={handleAddNewPlanClick}
                handleImageUrlChange={handleImageUrlChange}
                handleVideoUrlChange={handleVideoUrlChange}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <RecipeTable
            header={tableHeader}
            plans={paginatedPlans}
            error={error}
            convertTimestamp={convertTimestamp}
            onEditClick={handleEditClick}
            toggleStatus={toggleStatus}
            handleDelete={handleDelete}
          />
          {/* Pagination */}
          {totalPages >= 1 && (
            <nav className="mt-3">
              <ul className="pagination justify-content-center">
                {/* Previous Button */}
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                    &laquo;
                  </button>
                </li>

                {/* Page Numbers */}
                {[...Array(totalPages)].map((_, i) => {
                  const pageNumber = i + 1;
                  return (
                    (pageNumber <= 2 || pageNumber >= totalPages - 1 || (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)) && (
                      <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? "active" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(pageNumber)}>
                          {pageNumber}
                        </button>
                      </li>
                    )
                  );
                })}

                {/* Next Button */}
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                    &raquo;
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddNewRecipe;
